// eslint-disable-next-line import/prefer-default-export

export const isMobile = () => window.matchMedia('only screen and (max-width: 760px)').matches;

export const initSafariCacheFix = () => {
  window.onpageshow = (event) => {
    if (event.persisted) {
      window.location.reload();
    }
  };
};

export const notEmpty = (val) => val && val.length > 0;

export const stopPropagation = (e) => e.stopPropagation();

export const scrollToError = () => {
  setTimeout(() => {
    const error = document.querySelectorAll('[error="true"]')[0];

    if (error) {
      error.parentElement.scrollIntoView({
        behavior: 'smooth',
      });
    }
  }, 10);
};

export const capitalize = (str, seperators) => {
  if (str) {
    let tempStr = str.toLowerCase().split(' ');

    for (let i = 0; i < tempStr.length; i += 1) {
      tempStr[i] = tempStr[i].charAt(0).toUpperCase() + tempStr[i].slice(1);
    }
    tempStr = tempStr.join(' ');

    tempStr = tempStr.split('-');

    for (let i = 0; i < tempStr.length; i += 1) {
      tempStr[i] = tempStr[i].charAt(0).toUpperCase() + tempStr[i].slice(1);
    }

    tempStr = tempStr.join('-');
    if (seperators && seperators.length > 0) {
      for (let i = 0; i < seperators.length; i += 1) {
        tempStr = tempStr.split(seperators[i]);

        for (let j = 0; j < tempStr.length; j += 1) {
          tempStr[j] = tempStr[j].charAt(0).toUpperCase() + tempStr[j].slice(1);
        }
        tempStr = tempStr.join(seperators[i]);
      }
    }

    return tempStr;
  }

  return null;
};

export const validateEmail = (email) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const renderRatingDescription = (rating) => {
  let description = '';

  if (rating >= 4) {
    description = 'Highly likely to recommend';
  } else if (rating >= 3) {
    description = 'Likely to recommend';
  } else if (rating > 2.5) {
    description = 'Not likely to recommend';
  } else {
    description = 'Does not recommend';
  }

  return description;
};

export const renderCustomerDescription = (review) => {
  const name = review.client_name || review.clientName;
  const type = review.client_type || review.clientType;
  const city = review.client_city || review.clientCity;
  let description = '';

  description += name;
  if (type && type !== 'n/a') {
    if (type.toLowerCase() === 'buyer') {
      description += ' bought a home';
    } else if (type.toLowerCase() === 'seller') {
      description += ' sold a home';
    } else if (type.toLowerCase() === 'both') {
      description += ' bought and sold a home';
    }
  }

  if (city) {
    description += ` in ${city}`;
  }

  return description;
};

export const capitalizeFirstLetter = (string) => (
  string.charAt(0).toUpperCase() + string.slice(1)
);

const fallbackCopyTextToClipboard = (text) => {
  const textArea = document.createElement('textarea');
  textArea.value = text;

  // Avoid scrolling to bottom
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.position = 'fixed';

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    document.execCommand('copy');
  } catch (err) {
    console.error('Unable to copy', err);
  }

  document.body.removeChild(textArea);
};

export const copyTextToClipboard = (text) => {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text);
    return;
  }
  navigator.clipboard.writeText(text);
};

export const emptyFunction = () => { };
